
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import { login } from "../../comon/api/home";
export default {
name: "MobileLogin",
components: {
XButton,
Group,
XInput,
Actionsheet
},
data() {
return {
jsonData: {
username: "",
password: ""
}
};
},
methods: {
userLogin() {
if (this.jsonData.username == "") {
this.$vux.alert.show({
title: "提示",
content: "请输入账号"
});
return;
}
if (this.jsonData.password == "") {
this.$vux.alert.show({
title: "提示",
content: "请输入密码"
});
return;
}
this.$vux.loading.show({
text: "Loading"
});
login({
username: this.jsonData.username,
password: this.jsonData.password
})
.then(res => {
if (res.code == 200) {
localStorage.setItem("sessionId", res.data.sessionId);
localStorage.setItem("session_mobile", res.data.sessionId);
localStorage.setItem("userInfo", res.data.userInfo.menuId);
localStorage.setItem(
"userInfos",
JSON.stringify(res.data.userInfo)
);
this.$vux.loading.hide();
this.jsonData.username = "";
this.jsonData.password = "";
this.$router.replace({ path: "/mobile_home" });
} else {
this.$vux.loading.hide();
this.jsonData.username = "";
this.jsonData.password = "";
this.$vux.alert.show({
title: "提示",
content: `${res.msg}`
});
return;
}
})
.catch(err => {
console.log(err);
});
},
forgetpwd() {
this.$router.push("/mobile_forgetPwd");
}
}
};



// WEBPACK FOOTER //
// ./src/components/mobile/Login.vue